import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Flex, Segmented, Typography } from "antd";
import dayjs from "dayjs";

const { Title } = Typography;

const NavigationControl = ({ currentDate, setDate, view, onViewChange }) => {
  const getUnit = () => {
    if (view === "month") return "month";
    if (view === "week") return "week";
    return "day";
  };

  const normalized = dayjs(currentDate).startOf(getUnit());

  // ✅ view k hisaab se title format
  const getTitle = () => {
    if (view === "week") {
      const startOfWeek = dayjs(currentDate).startOf("week");
      const endOfWeek = dayjs(currentDate).endOf("week");
      return `(${startOfWeek.format("D")} - ${endOfWeek.format("D")}) ${startOfWeek.format("MMMM YYYY")}`;
    }
    if (view === "day") {
      return dayjs(currentDate).format("MMMM D, YYYY");
    }
    return dayjs(currentDate).format("MMMM YYYY");
  };

  return (
    <Flex justify="space-between" align="center" className="px-3 py-3">
      <Flex align="center" gap={8}>
        <Button onClick={() => setDate(new Date())}>Today</Button>

        <Button
          icon={<LeftOutlined />}
          onClick={() => setDate(normalized.subtract(1, getUnit()).toDate())}
        />

        <Button
          icon={<RightOutlined />}
          onClick={() => setDate(normalized.add(1, getUnit()).toDate())}
        />

        <Title level={5} className="m-0">
          {getTitle()} {/* ✅ dynamic title */}
        </Title>
      </Flex>

      <Segmented
        value={view}
        onChange={onViewChange}
        options={[
          { label: "Month", value: "month" },
          { label: "Week", value: "week" },
          { label: "Day", value: "day" },
        ]}
      />
    </Flex>
  );
};

export { NavigationControl };
